import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  isLoaderDisable = false;
  isLoaderVisible = new Subject<boolean>();
  isLoaderVisibleKey: Record<string, boolean> = {};
  loaderMessage = new BehaviorSubject<string>('');
  isSectionWiseLoaderVisible = new BehaviorSubject<boolean>(false);
  isKeyWiseLoaderVisible: Record<string, boolean> = {};

  private activeRequests = 0;
  private sectionWiseActiveRequests = 0;

  /**
   * Increment the active API request count
   */
  showLoader() {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.isLoaderVisible.next(true);
    }
  }

  showSectionWiseLoader(key: string) {
    this.sectionWiseActiveRequests++;
    this.isKeyWiseLoaderVisible[key] = true;
    this.isSectionWiseLoaderVisible.next(true);
    // if (this.sectionWiseActiveRequests === 1) {
    // }
  }

  /**
   * Update Loader Message
   */
  updateLoaderMessage(message: string) {
    this.loaderMessage.next(message);
  }

  /**
   * Decrement the active API request count and hide the loader if no more requests are active
   */
  hideLoader() {
    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.isLoaderVisible.next(false);
    } // Prevent negative numbers
  }

  hideSectionWiseLoader(key: string) {
    this.sectionWiseActiveRequests--;
    delete this.isKeyWiseLoaderVisible[key];
    this.isSectionWiseLoaderVisible.next(false);
    if (this.sectionWiseActiveRequests <= 0) {
      this.sectionWiseActiveRequests = 0;
    }
  }
}
